module.exports = __webpack_public_path__ + "static/media/sam.b10c4072.jpg";